import { Image } from "@/components/Image/Image";
import { HotelImageCounter } from "@/features/hotels/components/hotel/HotelImageCounter";
import type { RoomImage } from "@/features/hotels/types/types";

type Props = {
  onClick: () => void;
  thumbnailImage: RoomImage;
  imageCount: number;
};

export const RoomGalleryButton = ({
  onClick,
  thumbnailImage,
  imageCount,
}: Props) => {
  return (
    <button
      type="button"
      className="relative h-30 w-22.5 shrink-0 overflow-clip rounded-2xl"
      onClick={onClick}
    >
      <Image
        className="h-full w-full object-cover"
        src={thumbnailImage.url}
        alt={thumbnailImage.name}
      />

      {imageCount > 1 && (
        <div className="absolute start-1 bottom-1">
          <HotelImageCounter count={imageCount} />
        </div>
      )}
    </button>
  );
};
